<template>
  <div id="solution-detail">
    <header-section :subnav_show="false" :change_color="true"></header-section>
    
    <!-- ======= Hero Section ======= -->
<div id="hero-solution-detail" data-aos="zoom-out" data-aos-delay="100">
  <div class="width_center_1200">
            <div class="solution-banner_content">
                <p class="solution-banner_title">{{this.articleDetail.title}}</p>
                <p class="solution-banner_desc" v-html="this.articleDetail.summary"></p>
<!--                <button type="button" class="el-button solution-banner_btn el-button&#45;&#45;blue_white">-->
<!--                    <span>方案咨询</span>-->
<!--                </button>-->
            </div>
        </div>
</div>
<!-- ======= solutions Section ======= -->
<div id="solutions" class="width_center_1200">
    <div class="container" data-aos="fade-up" v-html="this.articleDetail.content"></div>
</div>
    <!-- footer -->
    <footer-section></footer-section>
  </div>
</template>
<script>
import HeaderSection from "@/components/public/head.vue"
import FooterSection from "@/components/public/footer.vue"

export default {
  components: {
    HeaderSection,
    FooterSection
  },
  props: {},
    data() {
      return {
        articleId: 0,
        articleDetail: {},
      };
    },
    watch: {
    },
    computed: {
    },
    methods: {
        //动态修改浏览器标题
        setBrowserTitle(title) {
        document.title = title;
        },
        //动态添加meta标签 keywords content
        addMetaKeyWords (keywords) {
            let m = document.querySelectorAll('meta');
            for(let i=0;i<m.length;i++){
                if(m[i].content ==keywords){
                    m[i].remove()
                }
            }
            const meta = document.createElement('meta')
            meta.name = 'keywords'
            meta.content = keywords
            document.head.appendChild(meta)
            
        },
        getArticleDetail(){
        this.$get(this.$api.getArticleDetail+"/"+this.articleId).then(response=>{
          if(response.code===0){
            this.articleDetail = response.data;
            this.setBrowserTitle(response.data.title)
            this.addMetaKeyWords(response.data.title)
            this.loading = false
          }else{
            window.console.log(response.msg);
          }
        });
      }
    },
    created() {
      this.articleId = this.$route.params.id;
      if(this.$isEmpty(this.articleId)){
            return this.$message.error('请检查信息是否存在');
      }
      this.getArticleDetail();
    },
    mounted() {
    },
    destroyed(){
        document.title='河北科瑞达仪器科技股份有限公司-官方网站'
    }
};
</script>
<style scoped>
/*--------------------------------------------------------------
# solution detail
--------------------------------------------------------------*/
#hero-solution-detail {
    width: 100%;
    height: 40vh;
    background: url("~@/static/img/channel/solution-banner-bg.jpg");
    background-size: cover;
    position: relative;
}
/* .solution-banner {
    padding: 145px 0 100px;
    position: relative;
} */
.solution-banner_picture {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
}

.solution-banner_bg {
    height: 100%;
    width: 100%;
    -o-object-fit: cover;
    object-fit: cover;
}

.solution-banner_content {
    padding-top: 50px;
}

.solution-banner_name {
    font-size: 18px;
    line-height: 18px;
    color: #222;
    margin-bottom: 24px;
}

.solution-banner_title {
    font-size: 42px;
    font-weight: 700;
    line-height: 42px;
    color: #222;
    margin-bottom: 32px;
}

.solution-banner__desc {
    font-size: 18px;
    line-height: 28px;
    color: #666;
    margin-bottom: 24px;
}

.solution-banner_btn {
    width: 160px;
    height: 48px;
    font-size: 16px;
}
.solution_title {
    font-size: 34px;
    font-weight: 700;
    color: #222;
    line-height: 34px;
    padding: 80px 0 32px;
}
.solution_desc {
    font-size: 14px;
    color: #333;
    line-height: 26px;
}
.solution_sub_part .solution_reason_bg {
    width: 100%;
    padding-bottom: 80px;
    background: rgba(238,241,244,.6);
}
.solution_sub_part .solution_title {
    position: relative;
    font-size: 34px;
    line-height: 34px;
    font-weight: 700;
    padding-top: 80px;
    padding-bottom: 32px;
}
.solution_sub_part .solution_text1 {
    font-size: 14px;
    line-height: 32px;
    color: #222;
}
.solution_sub_part .solution_editor {
    position: relative;
}
.solution_sub_part .solution_editor p {
    line-height: 1.4!important;
}
.solution_sub_part .solution_result_bg {
    width: 100%;
    min-height: 400px;
    padding-bottom: 32px;
    position: relative;
}
.solution_sub_part .solution_bottom_img {
    width: 100%;
    position: absolute;
    bottom: 0;
}
.solution_sub_part .solution_text7 {
    position: relative;
    font-size: 14px;
    line-height: 30px;
    color: #222;
}
.solution_sub_part .solution_result_data {
    padding-top: 44px;
}
.solution_sub_part .solution_result_item {
    width: 33.3%;
    margin-bottom: 48px;
}
.solution_sub_part .solution_solution_bg {
    padding-bottom: 80px;
}
.solution_sub_part .solution_solution_item .solution_text5 {
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    color: #222;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.solution_sub_part .solution_text6 {
    height: 52px;
    font-size: 14px;
    line-height: 26px;
    color: #666;
    margin-top: 16px;
    margin-bottom: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.solution_sub_part .solution_solution_item .solution_btn {
    background: transparent;
    font-size: 16px;
    color: #1989fa;
    height: 16px;
    padding: 0;
    border: 0;
}
.container{
    font-size: 14px;
    line-height: 200%;
}
.container >>> img {
    max-width: 100%;
    height: auto;
}
.container >>> ul{
    list-style: disc;
    padding-left: 40px;
}
.container >>> ol{
    list-style: decimal;
}
</style>